import * as Sentry from "@sentry/react";
import { getEnvByDomain } from "./utils/get-env-by-domain";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://b4ab7073762c589323ba6fccd26b4185@o4509316676845568.ingest.us.sentry.io/4510327102308352",
    sendDefaultPii: true,
    environment: getEnvByDomain(),
  });
}
